import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DocRequestComponent } from './docRequest.component';
import { FormsModule }   from '@angular/forms';
import { SharedModule } from '../shared/shared.module';

@NgModule({
    imports: [CommonModule, FormsModule, SharedModule],
    declarations: [DocRequestComponent],
    exports: [DocRequestComponent]
})

export class DocRequestModule { }
